"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    backgroundColor: "white",
    color: "black"
  },
  section: {
    height: theme.spacing(8),
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  button: {
    width: theme.spacing(6),
    height: theme.spacing(6),
    color: "inherit",
    "& + $content": {
      paddingRight: theme.spacing(8)
    }
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  title: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "bold",
    marginLeft: theme.spacing(1)
  },
  subtitle: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "18px",
    fontWeight: "normal",
    marginLeft: "0.25em"
  }
}));

const AppSubview = ({
  className,
  expanded,
  title,
  subtitle,
  onBack
}) => {
  const classes = useStyles();
  return _react.default.createElement("div", {
    className: className || classes.root,
    "aria-expanded": expanded
  }, _react.default.createElement("div", {
    className: classes.section
  }, _react.default.createElement(_IconButton.default, {
    className: classes.button,
    onClick: onBack
  }, _react.default.createElement(_ArrowBack.default, null)), _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement(_Typography.default, {
    component: "h1",
    className: classes.title
  }, title && subtitle && title + ":" || title), _react.default.createElement(_Typography.default, {
    component: "h2",
    className: classes.subtitle
  }, subtitle))));
};

var _default = AppSubview;
exports.default = _default;
module.exports = exports.default;